/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * GlobeIcon - Auto-generated from icon
 */
export const GlobeIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2 10H18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9.9998 2C12.0008 4.19068 13.138 7.03363 13.1998 10C13.138 12.9664 12.0008 15.8093 9.9998 18C7.99878 15.8093 6.8616 12.9664 6.7998 10C6.8616 7.03363 7.99878 4.19068 9.9998 2Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default GlobeIcon;
